import * as React from 'react';
import { IChangeEventHandler } from '../../_types/nav';
import Switch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { ISelectorDefault, search_param } from '../../_types/search';

interface Props {
    onChange: IChangeEventHandler<search_param>;
    searchParam: search_param;
    selector_cn: string;
    disabled?: boolean;
};

export const TrueFalseSelectorDefaults = 
    (selector_cn: string): ISelectorDefault => {
        return { 
            comparison: "equals",
            values: ["1"]
        };
    };

const TrueFalseSelector: React.FC<Props> = (prop: Props) => {

    //const userState: IUserState = useContext(AuthContext);

    const getValueAsString = ():string => {
        let v = _value();
        if (prop.selector_cn === "selector.tf") {
            return v ? "True" : "False";
        }

        return v ? "Yes": "No";
        
    }

    const _value = ():boolean => {

        let  toReturn: boolean = false;
        if (prop.searchParam.values != null && prop.searchParam.values.length > 0) {
            toReturn = prop.searchParam.values[0] === "1";
        }
        return toReturn;
    }
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let checked = event.target.checked;
 
        let p = { ...prop.searchParam };
        p.values = [ checked ? "1": "0" ];
        p.comparison = "equals";
        prop.onChange(p);
    }

return (
    <FormControlLabel label={getValueAsString()}
    control = {<Switch disabled={prop.disabled} checked={_value()} onChange={handleChange} color="primary"/>} />
)
}

export default TrueFalseSelector;